/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsSyncReviewTaskFragment = { __typename: 'PdsSyncTask', id: string, entityType: Types.PdsSyncEntityType, targetId?: string | null, action: Types.PdsSyncTaskAction, status: Types.PdsSyncTaskStatus, displayName?: string | null, dependsOnResolved: boolean, dependsOnSourceIds: Array<string>, reviewedBy?: string | null, reviewedAt?: string | null, executedAt?: string | null, errorMessage?: string | null, createdAt: string, updatedAt: string, fieldChanges: Array<{ __typename: 'PdsSyncTaskFieldChange', field: string, label: string, newValue?: string | null }> };

export type PdsSyncReviewModal_TasksQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PdsSyncTaskFilter>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type PdsSyncReviewModal_TasksQuery = { pdsSyncTasks: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdsSyncTaskConnection', totalCount: number, items: Array<{ __typename: 'PdsSyncTask', id: string, entityType: Types.PdsSyncEntityType, targetId?: string | null, action: Types.PdsSyncTaskAction, status: Types.PdsSyncTaskStatus, displayName?: string | null, dependsOnResolved: boolean, dependsOnSourceIds: Array<string>, reviewedBy?: string | null, reviewedAt?: string | null, executedAt?: string | null, errorMessage?: string | null, createdAt: string, updatedAt: string, fieldChanges: Array<{ __typename: 'PdsSyncTaskFieldChange', field: string, label: string, newValue?: string | null }> }> } };

export type PdsSyncReviewModal_AppliedTodayCountQueryVariables = Types.Exact<{
  executedSince: Types.Scalars['String']['input'];
}>;


export type PdsSyncReviewModal_AppliedTodayCountQuery = { pdsSyncTaskCounts: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdsSyncTaskCounts', executedSince?: number | null } };

export type PdsSyncReviewModal_ApproveTasksMutationVariables = Types.Exact<{
  taskIds: Array<Types.Scalars['ID']['input']>;
}>;


export type PdsSyncReviewModal_ApproveTasksMutation = { approvePdsSyncTasks: { __typename: 'PdsSyncTaskBulkResult', succeeded: number, failed: Array<{ __typename: 'PdsSyncTaskBulkFailure', taskId: string, reason: string }> } };

export type PdsSyncReviewModal_RejectTasksMutationVariables = Types.Exact<{
  taskIds: Array<Types.Scalars['ID']['input']>;
}>;


export type PdsSyncReviewModal_RejectTasksMutation = { rejectPdsSyncTasks: { __typename: 'PdsSyncTaskBulkResult', succeeded: number, failed: Array<{ __typename: 'PdsSyncTaskBulkFailure', taskId: string, reason: string }> } };

export type PdsSyncReviewModal_RetryTaskMutationVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type PdsSyncReviewModal_RetryTaskMutation = { retryPdsSyncTask: { __typename: 'PdsSyncTask', id: string, status: Types.PdsSyncTaskStatus, errorMessage?: string | null } };

export const PdsSyncReviewTaskFragmentDoc = gql`
    fragment PdsSyncReviewTask on PdsSyncTask {
  id
  entityType
  targetId
  action
  status
  displayName
  dependsOnResolved
  dependsOnSourceIds
  reviewedBy
  reviewedAt
  executedAt
  errorMessage
  createdAt
  updatedAt
  fieldChanges {
    field
    label
    newValue
  }
}
    `;
export const PdsSyncReviewModal_TasksDocument = gql`
    query PdsSyncReviewModal_Tasks($filter: PdsSyncTaskFilter, $limit: Int, $offset: Int) {
  pdsSyncTasks(filter: $filter, limit: $limit, offset: $offset) {
    ... on PdsSyncTaskConnection {
      items {
        ...PdsSyncReviewTask
      }
      totalCount
    }
  }
}
    ${PdsSyncReviewTaskFragmentDoc}`;

/**
 * __usePdsSyncReviewModal_TasksQuery__
 *
 * To run a query within a React component, call `usePdsSyncReviewModal_TasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewModal_TasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncReviewModal_TasksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePdsSyncReviewModal_TasksQuery(baseOptions?: Apollo.QueryHookOptions<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>(PdsSyncReviewModal_TasksDocument, options);
      }
export function usePdsSyncReviewModal_TasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>(PdsSyncReviewModal_TasksDocument, options);
        }
export function usePdsSyncReviewModal_TasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>(PdsSyncReviewModal_TasksDocument, options);
        }
export type PdsSyncReviewModal_TasksQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_TasksQuery>;
export type PdsSyncReviewModal_TasksLazyQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_TasksLazyQuery>;
export type PdsSyncReviewModal_TasksSuspenseQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_TasksSuspenseQuery>;
export type PdsSyncReviewModal_TasksQueryResult = Apollo.QueryResult<PdsSyncReviewModal_TasksQuery, PdsSyncReviewModal_TasksQueryVariables>;
export const PdsSyncReviewModal_AppliedTodayCountDocument = gql`
    query PdsSyncReviewModal_AppliedTodayCount($executedSince: String!) {
  pdsSyncTaskCounts(executedSince: $executedSince) {
    ... on PdsSyncTaskCounts {
      executedSince
    }
  }
}
    `;

/**
 * __usePdsSyncReviewModal_AppliedTodayCountQuery__
 *
 * To run a query within a React component, call `usePdsSyncReviewModal_AppliedTodayCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewModal_AppliedTodayCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncReviewModal_AppliedTodayCountQuery({
 *   variables: {
 *      executedSince: // value for 'executedSince'
 *   },
 * });
 */
export function usePdsSyncReviewModal_AppliedTodayCountQuery(baseOptions: Apollo.QueryHookOptions<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables> & ({ variables: PdsSyncReviewModal_AppliedTodayCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>(PdsSyncReviewModal_AppliedTodayCountDocument, options);
      }
export function usePdsSyncReviewModal_AppliedTodayCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>(PdsSyncReviewModal_AppliedTodayCountDocument, options);
        }
export function usePdsSyncReviewModal_AppliedTodayCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>(PdsSyncReviewModal_AppliedTodayCountDocument, options);
        }
export type PdsSyncReviewModal_AppliedTodayCountQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_AppliedTodayCountQuery>;
export type PdsSyncReviewModal_AppliedTodayCountLazyQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_AppliedTodayCountLazyQuery>;
export type PdsSyncReviewModal_AppliedTodayCountSuspenseQueryHookResult = ReturnType<typeof usePdsSyncReviewModal_AppliedTodayCountSuspenseQuery>;
export type PdsSyncReviewModal_AppliedTodayCountQueryResult = Apollo.QueryResult<PdsSyncReviewModal_AppliedTodayCountQuery, PdsSyncReviewModal_AppliedTodayCountQueryVariables>;
export const PdsSyncReviewModal_ApproveTasksDocument = gql`
    mutation PdsSyncReviewModal_ApproveTasks($taskIds: [ID!]!) {
  approvePdsSyncTasks(taskIds: $taskIds) {
    succeeded
    failed {
      taskId
      reason
    }
  }
}
    `;
export type PdsSyncReviewModal_ApproveTasksMutationFn = Apollo.MutationFunction<PdsSyncReviewModal_ApproveTasksMutation, PdsSyncReviewModal_ApproveTasksMutationVariables>;

/**
 * __usePdsSyncReviewModal_ApproveTasksMutation__
 *
 * To run a mutation, you first call `usePdsSyncReviewModal_ApproveTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewModal_ApproveTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncReviewModalApproveTasksMutation, { data, loading, error }] = usePdsSyncReviewModal_ApproveTasksMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function usePdsSyncReviewModal_ApproveTasksMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncReviewModal_ApproveTasksMutation, PdsSyncReviewModal_ApproveTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncReviewModal_ApproveTasksMutation, PdsSyncReviewModal_ApproveTasksMutationVariables>(PdsSyncReviewModal_ApproveTasksDocument, options);
      }
export type PdsSyncReviewModal_ApproveTasksMutationHookResult = ReturnType<typeof usePdsSyncReviewModal_ApproveTasksMutation>;
export type PdsSyncReviewModal_ApproveTasksMutationResult = Apollo.MutationResult<PdsSyncReviewModal_ApproveTasksMutation>;
export type PdsSyncReviewModal_ApproveTasksMutationOptions = Apollo.BaseMutationOptions<PdsSyncReviewModal_ApproveTasksMutation, PdsSyncReviewModal_ApproveTasksMutationVariables>;
export const PdsSyncReviewModal_RejectTasksDocument = gql`
    mutation PdsSyncReviewModal_RejectTasks($taskIds: [ID!]!) {
  rejectPdsSyncTasks(taskIds: $taskIds) {
    succeeded
    failed {
      taskId
      reason
    }
  }
}
    `;
export type PdsSyncReviewModal_RejectTasksMutationFn = Apollo.MutationFunction<PdsSyncReviewModal_RejectTasksMutation, PdsSyncReviewModal_RejectTasksMutationVariables>;

/**
 * __usePdsSyncReviewModal_RejectTasksMutation__
 *
 * To run a mutation, you first call `usePdsSyncReviewModal_RejectTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewModal_RejectTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncReviewModalRejectTasksMutation, { data, loading, error }] = usePdsSyncReviewModal_RejectTasksMutation({
 *   variables: {
 *      taskIds: // value for 'taskIds'
 *   },
 * });
 */
export function usePdsSyncReviewModal_RejectTasksMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncReviewModal_RejectTasksMutation, PdsSyncReviewModal_RejectTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncReviewModal_RejectTasksMutation, PdsSyncReviewModal_RejectTasksMutationVariables>(PdsSyncReviewModal_RejectTasksDocument, options);
      }
export type PdsSyncReviewModal_RejectTasksMutationHookResult = ReturnType<typeof usePdsSyncReviewModal_RejectTasksMutation>;
export type PdsSyncReviewModal_RejectTasksMutationResult = Apollo.MutationResult<PdsSyncReviewModal_RejectTasksMutation>;
export type PdsSyncReviewModal_RejectTasksMutationOptions = Apollo.BaseMutationOptions<PdsSyncReviewModal_RejectTasksMutation, PdsSyncReviewModal_RejectTasksMutationVariables>;
export const PdsSyncReviewModal_RetryTaskDocument = gql`
    mutation PdsSyncReviewModal_RetryTask($taskId: ID!) {
  retryPdsSyncTask(taskId: $taskId) {
    id
    status
    errorMessage
  }
}
    `;
export type PdsSyncReviewModal_RetryTaskMutationFn = Apollo.MutationFunction<PdsSyncReviewModal_RetryTaskMutation, PdsSyncReviewModal_RetryTaskMutationVariables>;

/**
 * __usePdsSyncReviewModal_RetryTaskMutation__
 *
 * To run a mutation, you first call `usePdsSyncReviewModal_RetryTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewModal_RetryTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncReviewModalRetryTaskMutation, { data, loading, error }] = usePdsSyncReviewModal_RetryTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usePdsSyncReviewModal_RetryTaskMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncReviewModal_RetryTaskMutation, PdsSyncReviewModal_RetryTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncReviewModal_RetryTaskMutation, PdsSyncReviewModal_RetryTaskMutationVariables>(PdsSyncReviewModal_RetryTaskDocument, options);
      }
export type PdsSyncReviewModal_RetryTaskMutationHookResult = ReturnType<typeof usePdsSyncReviewModal_RetryTaskMutation>;
export type PdsSyncReviewModal_RetryTaskMutationResult = Apollo.MutationResult<PdsSyncReviewModal_RetryTaskMutation>;
export type PdsSyncReviewModal_RetryTaskMutationOptions = Apollo.BaseMutationOptions<PdsSyncReviewModal_RetryTaskMutation, PdsSyncReviewModal_RetryTaskMutationVariables>;